import React, { useContext } from "react";
import { Img } from "../../../../components/shared/img";
import { ASSETS_URL, store } from "../../../../components/Store";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useTranslationsById } from "../../../../hooks/use-translations-by-id";

/**
 * Tarjeta de libro usada por los planes de lectura.
 *
 * Resume el título seleccionado y expone sus acciones principales.
 */
export const BookCard = ({ book, loading, lang }) => {
	const texts = useTranslationsById({ mainSectionName: "reading_resources", language: lang });
	const globalState = useContext(store);
	const isAuth = globalState?.state?.sesionActiva === "SI";

	return (
		<article
			className="row p-0 m-0 w-100 h-100 book-card overflow-hidden align-items-stretch"
			style={{ minHeight: 437 }}
		>
			{loading ? (
				<div className="w-100 h-100 d-flex justify-content-center align-items-center">
					<Icon icon="icomoon-free:spinner9" width={60} className={"spinner-rotation"} />
				</div>
			) : (
				<>
					<div className="col-12 d-flex d-lg-none p-0 m-0 x justify-content-center align-items-center mt-5 px-2">
						<div className="" style={{ maxWidth: 200, minHeight: 310 }}>
							<Img
								src={`${ASSETS_URL}${book?.portada}`}
								alt="portada"
								className="img img-fluid"
								defaultImage={"/img/no-imagen.png"}
							/>
						</div>
					</div>
					<div className="col-12 col-md px-4 pt-4 pb-4 h-auto d-flex flex-column">
						<h2 className="title  title-font">
							{book?.title || book?.titulo || "N/A"}
						</h2>
						<div className="d-flex py-2 flex-wrap ">
							<p
								className="tag"
							>
								{book?.genero || "N/A"}
							</p>
							<div style={{ width: 10 }}></div>
							<p className="tag">
								{book?.editorial || "N/A"}
							</p>
						</div>
						<p className="author secondary-font font-weight-bold">
							{book?.autor || book?.author || "N/A"}
						</p>
						<hr className="my-4" />
						<p className="description" dangerouslySetInnerHTML={{
							__html: lang === "en"
								? book?.descripcionEn || book?.descripcion || "N/A"
								: book?.descripcion || "N/A"
						}}>
						</p>
						<div className="mt-auto pt-3">
							<a
								className="focusable-red buttonv2 button-primary my-4 focusable-red px-5"
								href={`${book?.link}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								{texts.getText({
									id: "planes.tarjeta_plan.boton.leer",
									defaultText: "Read",
								})}
							</a>
						</div>
					</div>
					<div
						className="col-12 col-md p-0 m-0 d-none d-lg-flex justify-content-center align-items-stretch book-card-media"
						style={{ maxWidth: 300 }}
					>
						<Img
							src={`${ASSETS_URL}${book?.portada}`}
							alt="portada"
							className="img w-100 h-100"
							defaultImage={"/img/no-imagen.png"}
						/>
					</div>
				</>
			)}
		</article>
	);
};
